import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchUsageAggregationHistory } from '../../../queries/fetch-usage-aggregation-history';

interface UseFetchUserHistoryGraphQueryVariables {
  entitlementId: string;
  transactionAccountId: string;
}

export const useFetchUsageHistoryGraphQuery = ({
  entitlementId,
  transactionAccountId,
}: UseFetchUserHistoryGraphQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery(fetchUsageAggregationHistory, {
    variables: {
      entitlementId,
      transactionAccountId,
    },
    skip: !entitlementId,
    client: ansClient,
  });
};
